import { __decorate } from 'tslib';
import { EventEmitter, Input, Output, ViewChild, Component, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { CountdownModule, CountdownGlobalConfig } from 'ngx-countdown';
import { UiCButtonModule } from '@wlp/ui-c-button';

let UiCSendCodeComponent = class UiCSendCodeComponent {
    constructor() {
        this.onChange = new EventEmitter();
        this.textActionEvent = new EventEmitter();
        this.actionCountDown = new EventEmitter();
    }
    textActionBtn() {
        this.countdown.restart();
        this.textActionEvent.emit();
    }
    focusValue(data) {
        // console.log('focusValue', data);
    }
    onKeyDown(evt) {
        const numKeyCode = [48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 8, 46];
        const iKeyCode = (evt.which) ? evt.which : evt.keyCode;
        // return !(iKeyCode !== 46 && iKeyCode > 31 && (iKeyCode < 48 || iKeyCode > 57));
        return numKeyCode.includes(iKeyCode);
    }
    nextElement(previusElement, currentElement, nextElement, event) {
        if (event.keyCode === 8) {
            if (!currentElement.value) {
                previusElement.focus();
                return;
            }
            return;
        }
        // console.log('onKeyUp', event);
        if (currentElement.value) {
            nextElement.focus();
        }
        if (currentElement === nextElement) {
            nextElement.blur();
        }
    }
    handleEvent($event) {
        this.actionCountDown.emit($event);
    }
};
__decorate([
    Input()
], UiCSendCodeComponent.prototype, "counter", void 0);
__decorate([
    Input()
], UiCSendCodeComponent.prototype, "errorMessages", void 0);
__decorate([
    Input()
], UiCSendCodeComponent.prototype, "textMessage", void 0);
__decorate([
    Input()
], UiCSendCodeComponent.prototype, "textAction", void 0);
__decorate([
    Input()
], UiCSendCodeComponent.prototype, "isDisabled", void 0);
__decorate([
    Input()
], UiCSendCodeComponent.prototype, "formSendCode", void 0);
__decorate([
    Input()
], UiCSendCodeComponent.prototype, "progressbarValue", void 0);
__decorate([
    Output()
], UiCSendCodeComponent.prototype, "onChange", void 0);
__decorate([
    Output()
], UiCSendCodeComponent.prototype, "textActionEvent", void 0);
__decorate([
    Output()
], UiCSendCodeComponent.prototype, "actionCountDown", void 0);
__decorate([
    ViewChild('cd', { static: false })
], UiCSendCodeComponent.prototype, "countdown", void 0);
UiCSendCodeComponent = __decorate([
    Component({
        selector: 'ui-c-send-code',
        template: "<div class=\"send-code-component\">\n  <form class=\"w100 ion-text-center\" [formGroup]=\"formSendCode\">\n    <!--   <div class=\"box-radius border\" tooltip=\"Verifique o c\u00F3digo e tente novamente\"\n      placement=\"top\" show-delay=\"500\" tooltipDisabled=\"{{showTooltip}}\"> -->\n\n    <div class=\"box-radius border\">\n      <input type=\"tel\" #codeOne maxlength=\"1\" formControlName=\"codeNumberOne\" (focus)=\"focusValue($event)\"\n        (keydown)=\"onKeyDown($event)\" (keyup)=\"nextElement(codeOne, codeOne, codeTwo, $event)\"\n        class=\"input-code code-number-one ion-text-center\" onfocus>\n      <input type=\"tel\" #codeTwo maxlength=\"1\" formControlName=\"codeNumberTwo\" (keydown)=\"onKeyDown($event)\"\n        (keyup)=\"nextElement(codeOne, codeTwo, codeThree, $event)\" class=\"input-code code-number-two ion-text-center\">\n      <input type=\"tel\" #codeThree maxlength=\"1\" formControlName=\"codeNumberThree\" (keydown)=\"onKeyDown($event)\"\n        (keyup)=\"nextElement(codeTwo, codeThree,  codeFour, $event)\"\n        class=\"input-code code-number-three ion-text-center\">\n      <input type=\"tel\" #codeFour maxlength=\"1\" formControlName=\"codeNumberFour\" (keydown)=\"onKeyDown($event)\"\n        (keyup)=\"nextElement(codeThree, codeFour, codeFive, $event)\"\n        class=\"input-code code-number-four ion-text-center\">\n      <input type=\"tel\" #codeFive maxlength=\"1\" formControlName=\"codeNumberFive\" (keydown)=\"onKeyDown($event)\"\n        (keyup)=\"nextElement(codeFour, codeFive, codeFive, $event)\" class=\"input-code code-number-five ion-text-center\">\n    </div>\n\n    <ion-row class=\"ion-padding ion-justify-content-center ion-align-items-center\">\n      <ion-col size=\"4\">\n        <countdown #cd class=\"font-weight-bold\" [config]=\"{leftTime: 1800, demand: true}\" (event)=\"handleEvent($event)\">\n        </countdown>\n      </ion-col>\n      <ion-col size=\"8\">\n        <ion-progress-bar class=\"ion-progress-bar\" [value]=\"progressbarValue\"></ion-progress-bar>\n      </ion-col>\n    </ion-row>\n\n    <ion-row>\n      <ion-col>\n        <!--      <ion-text class=\"text-action\" [ngClass]=\"isDisabled ? 'disabled-events' : ''\" (click)=\"textActionBtn()\">-->\n        <!--        <p class=\"ion-no-margin ion-margin-bottom\">{{textAction}}</p>-->\n        <!--      </ion-text>-->\n        <ui-c-button mode=\"text\" expand=\"block\" (continue)=\"textActionBtn()\" [disabled]=\"isDisabled\">\n          <span class=\"title-message\">{{textMessage}}</span> <span class=\"title\">{{textAction}}</span>\n        </ui-c-button>\n      </ion-col>\n    </ion-row>\n  </form>\n</div>\n",
        styles: [""]
    })
], UiCSendCodeComponent);

let UiCSendCodeModule = class UiCSendCodeModule {
};
UiCSendCodeModule = __decorate([
    NgModule({
        declarations: [UiCSendCodeComponent],
        imports: [
            IonicModule,
            CommonModule,
            CountdownModule,
            ReactiveFormsModule,
            UiCButtonModule,
        ],
        exports: [UiCSendCodeComponent, CountdownModule],
        providers: [
            { provide: CountdownGlobalConfig }
        ],
    })
], UiCSendCodeModule);

/*
 * Public API Surface of ui-c-send-code
 */

/**
 * Generated bundle index. Do not edit.
 */

export { UiCSendCodeComponent, UiCSendCodeModule };
//# sourceMappingURL=wlp-ui-c-send-code.js.map
